import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var MessageAddSVG = function MessageAddSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27,3H5A3,3,0,0,0,2,6V19a3,3,0,0,0,3,3H8v6a1,1,0,0,0,.08.38,1,1,0,0,0,.54.54.94.94,0,0,0,.76,0,1,1,0,0,0,.33-.21L16.41,22H27a3,3,0,0,0,3-3V6A3,3,0,0,0,27,3ZM20,13.5H17v3a1,1,0,0,1-2,0v-3H12a1,1,0,0,1,0-2h3v-3a1,1,0,0,1,2,0v3h3a1,1,0,0,1,0,2Z"
  }));
};
MessageAddSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(MessageAddSVG);